import { Shapes } from '@shared/core';
import { TableSizes } from '@shared/floor-plans';

export const DEFAULT_TABLES_DATA = {
  sizes: [
    {
      name: 'Small',
      value: TableSizes.small,
    },
    {
      name: 'Medium',
      value: TableSizes.medium,
    },
    {
      name: 'Large',
      value: TableSizes.large,
    },
    {
      name: 'Custom',
      value: TableSizes.custom,
    },
  ],
  shapes: [
    {
      name: 'Square',
      value: Shapes.square,
    },
    {
      name: 'Circle',
      value: Shapes.circle,
    },
    {
      name: 'Rectangular',
      value: Shapes.rectangular,
    },
  ],
};
